<template>
  <div>
    <br>
    <h5 class="pageTitle">Cours d'ornithologie offerts par le COQ</h5>
    <table id="professeur">
      <tr>
        <td style="padding-bottom:50px"><img :src="require('../../../public/images/hibou_livre.png')" alt="" /></td> <!-- Le padding sert à éloigner les onglets -->
        <td>
          <table>
            <tr>
              <td><h1 class="titre">Le Club offre deux catégories de cours portant sur l'ornithologie:</h1></td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td><img :src="require('../../../public/images/fleche_boulet.png')" alt="" /></td>
                    <td><h1>des cours <span style="color:#b1661b;">d'initiation;</span></h1></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td><img :src="require('../../../public/images/fleche_boulet.png')" alt="" /></td>
                    <td><h1>des cours <span style="color:#b1661b;">spécialisés.</span></h1></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>  <!-- Fin de 'professeur' -->

    <div id="intro">
      <h2 class="pageSubtitle2">Cours en réserve</h2>
      <p>Les cours <span style="color:#b1661b; font-weight:bold;">en réserve</span> sont des cours spécialisés qui ont déjà été donnés et qui
        peuvent l'être à nouveau si le contexte ou la demande s’y prêtent.<br/><br/>

        Vous retrouvez dans cette section le détail de chacun de ces cours. N'hésitez pas à manifester votre intérêt pour l'un de ces cours en
        communiquant avec le président
        du COQ par <a href="mailto:norbert.lacroix@mat.ulaval.ca?subject=Information à propos des cours en réserve">courriel</a>.</p><br/>
    </div>

    <!-- Onglets -->
    <div id="barreNavigation">
      <div id="liste">
        <ul>
          <li>
            <router-link :to="{ name: 'CoursInitPage' }">Cours d'initiation</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CoursSpecialisesPage' }">Cours spécialisés</router-link>
          </li>
        </ul>
      </div>
    </div><!-- Fin des onglets -->

    <div v-for="_class in cours" :key="_class._id">
      <class :_class="_class"/>
      <div class="separateur"></div>
    </div>

    <div v-if="cours.length === 0">
      <br />
      <p>Il n'y a pas de cours en réserve pour le moment.</p>
    </div>
  </div>
</template>

<script>
  import Class from '../../components/Cours/Cours';
  import CoursMixin from '@/pages/Cours/Cours.mixin';

  export default {
    name: 'CoursReserve',
    components: { Class },
    mixins: [ CoursMixin ],
    data() {
      return {
        classType: 'cours_en_reserve'
      };
    }
  };
</script>

<style scoped>
li {
  margin-bottom: 0 !important;
}

p a {
  font-size: 12px !important;
}
</style>
